import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
interface ScarcityBadgeProps {
  className?: string;
}
export const ScarcityBadge: React.FC<ScarcityBadgeProps> = ({
  className = ''
}) => {
  return <div className={`inline-flex items-center justify-center px-5 py-2.5 bg-[#0B0B0B]/80 border border-[#D4AF37] rounded-full transition-all duration-300 hover:shadow-[0_0_15px_rgba(212,175,55,0.35)] ${className}`} data-id="element-385">
      <div className="flex items-center space-x-2" data-id="element-386">
        <AlertTriangleIcon className="w-4 h-4 text-[#D4AF37]" data-id="element-387" />
        <span className="text-[#D4AF37] text-xs sm:text-sm font-bold uppercase tracking-wide" data-id="element-388">
          ⚠️ Edición Limitada • Solo 500 Copias
        </span>
      </div>
    </div>;
};